import { ReactElement } from "react";
import { Badge } from "@justworkshr/milo-core";

import { MFA_FACTOR_COPY } from "../../../mfa/constants/factorCopy";

import { FactorKey } from "types/factor/factor";
import { FACTOR_ORDER } from "pages/register/types/parsedTransactionFactorData";

import styles from "./active-factors.module.css";

const ActiveFactors = ({
  activeFactors,
}: {
  activeFactors: FactorKey[];
}): ReactElement => {
  const factorKeys = FACTOR_ORDER.filter((factorKey) =>
    activeFactors.includes(factorKey),
  );

  return (
    <>
      {factorKeys.map((factorKey, i) => {
        const copy = MFA_FACTOR_COPY[factorKey];

        return (
          <div key={i} className={styles.factorContainer}>
            {copy.title}
            <Badge role="info" className={styles.activeBadge}>
              Active
            </Badge>
          </div>
        );
      })}
    </>
  );
};

export default ActiveFactors;
